import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterBar = ({ filters, onFilterChange }) => {
  const dateRangeOptions = [
    { value: '7d', label: 'Last 7 Days' },
    { value: '30d', label: 'Last 30 Days' },
    { value: '90d', label: 'Last 90 Days' },
    { value: '1y', label: 'Last Year' },
    { value: 'all', label: 'All Time' }
  ];

  const tournamentTypeOptions = [
    { value: 'all', label: 'All Tournaments' },
    { value: 'T20', label: 'T20' },
    { value: 'ODI', label: 'ODI' },
    { value: 'Test', label: 'Test' }
  ];

  const predictionCategoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'winner', label: 'Match Winner' },
    { value: 'scorer', label: 'Top Scorer' },
    { value: 'wicket', label: 'Top Wicket Taker' },
    { value: 'motm', label: 'Man of the Match' }
  ];

  const handleReset = () => {
    onFilterChange({
      dateRange: '30d',
      tournamentType: 'all',
      predictionCategory: 'all'
    });
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-sm p-4 md:p-6 border border-border mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <Select
          label="Date Range"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => onFilterChange({ dateRange: value })}
        />
        
        <Select
          label="Tournament Type"
          options={tournamentTypeOptions}
          value={filters?.tournamentType}
          onChange={(value) => onFilterChange({ tournamentType: value })}
        />
        
        <Select
          label="Prediction Category"
          options={predictionCategoryOptions}
          value={filters?.predictionCategory}
          onChange={(value) => onFilterChange({ predictionCategory: value })}
        />
        
        <div className="flex items-end">
          <Button
            variant="outline"
            onClick={handleReset}
            className="w-full"
            iconName="RotateCcw"
          >
            Reset Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;